module.exports = __webpack_public_path__ + "img/mobil_zold_ikon.5168542a.svg";